import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { resourceDetailsResourceCoverageDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataSelector";
import { CommitmentCoverageData } from "@/services/cloudchipr.api";

export const resourceDetailsResourceCoverageGridDataSelector =
  createDraftSafeSelector(
    [resourceDetailsResourceCoverageDataSelector],
    (data): CommitmentCoverageData[] => {
      return (
        data?.grouped_coverage?.map((item) => ({
          ...item,
          id:
            item.commitment?.id ??
            `${item.covered_usage}_${item.coverage}_${item.uncovered_usage}_${item.net_savings}`,
        })) ?? []
      );
    },
  );
